module.exports = __webpack_public_path__ + "img/s3.dd953a42.jpg";